//onInput={(e) => e.target.parentNode.dataset.value = e.target.value}
//https://css-tricks.com/auto-growing-inputs-textareas/ couldn't get css to work
export const autoTextBoxHeight = (e: any) => {
    const textarea = e.target;
    const match = textarea.value.match(/\n/g);
    textarea.rows = match ? match.length + 1 : 1;
}

export const autoTextBoxHeightMax = (e: any) => {
    const textarea = e.target;
    const match = textarea.value.match(/\n/g);
    const rowHeight = match ? match.length + 1 : 1;
    const maxRowHeight = 4;
    textarea.rows = match
        ? rowHeight >= maxRowHeight
            ? maxRowHeight
            : rowHeight
        : 1;
}